import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";


export const GetSpandan = createAsyncThunk(
  "/website/spandan/spandan",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Spandan.GetSpandan);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllGetSpandan_Banner = createAsyncThunk(
  "/website/spandan/spandan-banner",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Spandan.AllGetSpandan_Banner);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllSpandan_Videos = createAsyncThunk(
  "/website/spandan/spandan-video",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Spandan.AllSpandan_Videos);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllSpandan_Session_Type = createAsyncThunk(
  "/website/spandan/spandan-session",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Spandan.AllSpandan_Session_Type);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const SingleSpandanSessionType = createAsyncThunk(
  "/website/spandan/spandan-session-single",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Spandan.AllSpandan_Session_Type}/${id}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const SpandanRegistration = createAsyncThunk(
  "/website/spandan/spandan-session-register",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Spandan.SpandanRegistration, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);





export const Slice = createSlice({
  name: "spandan",
  initialState: {

    all_spandan: [],
    all_spandan_session_type: [],
    all_spandan_banner: [],
    all_spandan_videos: [],
    spandan_session_type: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetSpandan.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSpandan.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_spandan = action.payload || [];
      })
      .addCase(GetSpandan.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllGetSpandan_Banner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGetSpandan_Banner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_spandan_banner = action.payload || [];
      })
      .addCase(AllGetSpandan_Banner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(AllSpandan_Videos.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSpandan_Videos.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_spandan_videos = action.payload || [];
      })
      .addCase(AllSpandan_Videos.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSpandan_Session_Type.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSpandan_Session_Type.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_spandan_session_type = action.payload || [];
      })
      .addCase(AllSpandan_Session_Type.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(SingleSpandanSessionType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SingleSpandanSessionType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.spandan_session_type = action.payload || [];
      })
      .addCase(SingleSpandanSessionType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });


  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
